import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const TestService = {
  // Define your API functions here
  create: async (data) => {
    const response = await apiService.post("/testpreparations", data);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/testpreparations/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getList: async ({  page = 1, pageSize = 10 }) => {
    const params = new URLSearchParams({
    //   ...(search && { search }),
    //   ...(status && { status }),

      page: page.toString(),
      pageSize: pageSize.toString(),
    });

    const response = await apiService.get(`/testpreparations?${params.toString()}`);
    return response.data;
  },
  getDetail: async (id) => {
    const response = await apiService.get(`/testpreparations/${id}`);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiService.delete(`/testpreparations/${id}`);
    return response.data;
  },
};

export default TestService;
